import network from '../../utils/network';
import config from '../../config';
import { ACTION_BEGIN, ACTION_FAILURE } from '../app';

export const FETCH_GLOBAL_ADMIN_STATS_DAT_SUCCESS = 'FETCH_GLOBAL_ADMIN_STATS_DAT_SUCCESS';
export const FETCH_GLOBAL_ADMIN_STATS_JSON_SUCCESS = 'FETCH_GLOBAL_ADMIN_STATS_JSON_SUCCESS';
export const GET_SUBSCRIPTION_INFO_SUCCESS = 'GET_SUBSCRIPTION_INFO_SUCCESS';
export const FETCH_BILLABLE_INFO_SUCCESS = 'FETCH_BILLABLE_INFO_SUCCESS';
export const FETCH_REPO_INFO_SUCCESS = 'FETCH_REPO_INFO_SUCCESS';
export const FETCH_PRICE_INFO_SUCCESS = 'FETCH_PRICE_INFO_SUCCESS';

export const fetchGlobalAdminStatsDat = () =>
  network.actionWrapper(
      `${config.getApiUrl()}/global-admin-stats.dat`,
      {
          begin: ACTION_BEGIN,
          success: FETCH_GLOBAL_ADMIN_STATS_DAT_SUCCESS,
          failure: ACTION_FAILURE,
      });

export const fetchGlobalAdminStatsJson = () =>
    network.actionWrapper(
        `${config.getApiUrl()}/global-admin-stats.json`,
        {
          begin: ACTION_BEGIN,
          success: FETCH_GLOBAL_ADMIN_STATS_JSON_SUCCESS,
          failure: ACTION_FAILURE,
        });

export const getSubscriptionData = (startDate, endDate) =>
    network.actionWrapper(`${config.getAppUrl()}/subscriptions/get-subscription-info/${startDate}:${endDate}`, {
      begin: ACTION_BEGIN,
      success: GET_SUBSCRIPTION_INFO_SUCCESS,
      failure: ACTION_FAILURE,
    });

export const fetchBillableInfo = () =>
    network.actionWrapper(`${config.getAppUrl()}/statisticstool/get-billable-info`, {
      begin: ACTION_BEGIN,
      success: FETCH_BILLABLE_INFO_SUCCESS,
      failure: ACTION_FAILURE,
    });

export const fetchRepoInfo = () =>
    network.actionWrapper(`${config.getAppUrl()}/statisticstool/get-repo-info`, {
      begin: ACTION_BEGIN,
      success: FETCH_REPO_INFO_SUCCESS,
      failure: ACTION_FAILURE,
    });

export const fetchPriceInfo = () =>
  network.actionWrapper(`${config.getAppUrl()}/subscriptions/get-price-info`, {
    begin: ACTION_BEGIN,
    success: FETCH_PRICE_INFO_SUCCESS,
    failure: ACTION_FAILURE,
  });
